import React, { Component } from "react";
import { USER_TYPE } from "../../../../store/types";
import { ChatComponent } from "../../../chat/Chat";

export class Messages extends Component<any, any> {
  render() {
    return <ChatComponent group={this.props.group} userType={USER_TYPE.PATIENT} />;
  }
}
